import React from 'react'
import { useIntl } from 'react-intl'
import {
  FormSubGroup,
  FormSubGroupHeader,
  FormSubGroupHeading,
  Section,
  SectionColumn,
  Row,
  Column,
} from '../../../../components/layout'
import { DateInput, SelectInput, TextAreaInput, TextInput } from '../../../../components/layout/form/input'
import { serviceTypeOptions } from '../../../TowingOrderPage/options'
import { useSettings } from '../../../Parameters'
import { messages } from '../../../../components/TowingCommon/JobDetails/messages'
import { translateInputOptions } from '../../../../util/translateInputOptions'

export const TowingRecordDetailsSubFormContents: React.FunctionComponent = () => {
  const { formatMessage } = useIntl()
  const settings = useSettings()
  const translatedServiceTypeOptions = translateInputOptions(serviceTypeOptions, formatMessage)

  if (!settings) {
    return null
  }

  return (
    <>
      <FormSubGroupHeader>
        <Row justify="space-between">
          <Column>
            <FormSubGroupHeading>{formatMessage(messages.jobInfoHeader)}</FormSubGroupHeading>
          </Column>
        </Row>
      </FormSubGroupHeader>
      <FormSubGroup>
        <Section columns={2}>
          <SectionColumn>
            <DateInput label={formatMessage(messages.towingDateLabel)} name="jobDetails.towingDate" required />
          </SectionColumn>
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextInput label={formatMessage(messages.orderReferenceLabel)} name="jobDetails.orderReference" />
          </SectionColumn>
          <SectionColumn>
            <TextInput label={formatMessage(messages.incidentCaseNoLabel)} name="jobDetails.incidentCaseNo" />
          </SectionColumn>
        </Section>
        <Section columns={2}>
          <SelectInput
            label={formatMessage(messages.towingReasonLabel)}
            name="jobDetails.towingReason"
            options={settings.towingReasons.map((label: string) => ({
              label,
              value: label,
            }))}
          />
          <SelectInput
            label={formatMessage(messages.serviceTypeLabel)}
            name="jobDetails.serviceType"
            options={translatedServiceTypeOptions}
          />
        </Section>
        <Section columns={2}>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.additionalInfoLabel)} name="jobDetails.additionalInfo" />
          </SectionColumn>
          <SectionColumn>
            <TextAreaInput label={formatMessage(messages.notesLabel)} name="jobDetails.notes" />
          </SectionColumn>
        </Section>
      </FormSubGroup>
    </>
  )
}
